import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { CandidateService } from 'src/app/services/CandidateService';
import { JobService } from 'src/app/services/job.service';
import { CommunicationService } from 'src/shared/services/CommunicationService';

@Component({
  selector: 'app-jobs-candidates-slide-filter',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './jobs-candidates-slide-filter.component.html',
  styleUrls: ['./jobs-candidates-slide-filter.component.scss']
})
export class JobsCandidatesSlideFilterComponent implements OnInit ,OnDestroy  {

  @ViewChild('stickyFilterHeader') stickyFilterHeader: ElementRef
  @Input() valuesSentForFilters;
  @Output() valuesRetainedForFilters = new EventEmitter<any>(null);

  scrollPosition = 0;
  showComponentA: boolean = true;
  restoreScrollPosition: any;
  isOpen = false;
  panel: string;

  private toggleSub?: Subscription;

  constructor(private jobService: JobService, private candidateService: CandidateService,private communicationService: CommunicationService) {
    this.toggleSub = this.jobService.getSliderToggle().subscribe(values => {
      const wasOpen = this.isOpen;
      this.isOpen = values.value;
      this.panel = values.panel;

      if (values.value && !wasOpen) {
        this.armDismissGuard();
      } else if (!values.value) {
        clearTimeout(this.dismissGuardTimer);
        this.dismissGuardTimer = null;
      }

      // Lock background body scroll when the slider opens, restore it
      // when it closes. Mirrors the route-based lock applied by
      // app.component for /newjobs and /newcandidates, so pages like
      // Job Center / Talent Center / Talent Pool (which aren't in that
      // route list) also get a non-scrollable background while the
      // filter is open.
      if (values.value) {
        document.body.classList.add('filter-slider-open');
        // Re-opening the slider always lands the user at the top of
        // the filter list — without this, the body retains the
        // scrollTop from the previous interaction and re-opens
        // half-scrolled. Wrap in setTimeout(0) so it runs after Angular
        // applies the slider-open class and the panel becomes
        // scrollable.
        setTimeout(() => {
          const body = document.getElementById('slider-filter-body');
          if (body) body.scrollTop = 0;
          const content = document.getElementById('slider-filter-content');
          if (content) content.scrollTop = 0;
        }, 0);
      } else {
        document.body.classList.remove('filter-slider-open');
      }
    })
  }


  ngOnInit() {
    this.communicationService.triggerMethod('reset');
   }

  ngOnDestroy(): void {
    this.toggleSub?.unsubscribe();
    clearTimeout(this.dismissGuardTimer);
    // Leaving the page with the panel open used to leave the body scroll
    // locked, because only the close handler removed this class.
    document.body.classList.remove('filter-slider-open');
  }

  /** How long after the panel opens its dismiss controls stay inert. */
  private static readonly DISMISS_GUARD_MS = 500;
  private dismissGuardTimer: any = null;

  private armDismissGuard(): void {
    clearTimeout(this.dismissGuardTimer);
    this.dismissGuardTimer = setTimeout(
      () => { this.dismissGuardTimer = null; },
      JobsCandidatesSlideFilterComponent.DISMISS_GUARD_MS
    );
  }

  /** Gate for every control that dismisses the panel — Filter, Reset, the X
   *  and the click-outside overlay.
   *
   *  Opening the panel renders `#slider-filter-overlay` across the whole
   *  viewport, directly over the "All Filters" button that was just clicked.
   *  So the next click of a burst lands on the overlay and dismisses the
   *  panel, and the one after that hits the button again and reopens it. Each
   *  swallowed click re-arms the window, so hammering the button can never
   *  toggle it; the timer always expires, so a deliberate click-away after a
   *  pause behaves exactly as before.
   *
   *  Same fix as the profile drawer's backdrop (SlidePanelComponent
   *  .onBackdropClick), where a console trace confirmed this mechanism. */
  private canDismiss(): boolean {
    if (!this.isOpen) return false;
    if (this.dismissGuardTimer !== null) {
      this.armDismissGuard();
      return false;
    }
    return true;
  }

  executeMethod(data: string): void {
    this.resetFilter(data);


  }

  previousValue_jobDetails:any={};
  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes.valuesRetainedForFilters)
    // console.log(changes.filterChanges)
    if(changes.valuesSentForFilters!==undefined && changes.valuesSentForFilters.currentValue != undefined){

    //  this.startFilter(this.valuesSentForFilters.entity)

    }

  }



  closeSlider() {
    if (!this.canDismiss()) return;
    this.jobService.setSliderToggle(false, this.panel, null,false);
    window.scrollTo(0, this.restoreScrollPosition);
  }

  startFilter(value) {
    if (!this.canDismiss()) return;
    if (value === 'jobs') {
      this.valuesRetainedForFilters.emit(value);
    } else if (value === 'candidates') {
      this.valuesRetainedForFilters.emit(value);
    } else if (value == 'job applicants') {
      let data: any = {}
      const jobApplicantStatus = JSON.parse(localStorage.getItem('jobApplicantStatus'))
      data.jobApplicantStatus = jobApplicantStatus;
      const jsonData = JSON.stringify(data);
      this.valuesRetainedForFilters.emit(jsonData);
    } else if (value == 'candidates invited') {
      let data: any = {}
      const candidatesInvitedStatus = JSON.parse(localStorage.getItem('candidatesInvitedStatus'))
      data.candidatesInvitedStatus = candidatesInvitedStatus;
      const jsonData = JSON.stringify(data);
      this.valuesRetainedForFilters.emit(jsonData);
    } else if(value == 'jobs applied') {
       let data: any = {}
      const jobsAppliedStatus = JSON.parse(localStorage.getItem('jobsAppliedStatus'))
      data.jobsAppliedStatus = jobsAppliedStatus;
      const jsonData = JSON.stringify(data);
      console.log(jobsAppliedStatus);

      this.valuesRetainedForFilters.emit(jsonData);
    } else if (value == 'job invites') {
      let data: any = {}
      const jobInvitesStatus = JSON.parse(localStorage.getItem('jobInvitesStatus'))
      data.jobInvitesStatus = jobInvitesStatus;
      const jsonData = JSON.stringify(data);
      this.valuesRetainedForFilters.emit(jsonData);
    }
    this.jobService.setSliderToggle(false, value, null,false);
  }

  resetFilter(value) {
    if (!this.canDismiss()) return;
    if(value === "jobs"){
      this.valuesRetainedForFilters.emit("reset");
      this.jobService.setSliderToggle(false, value, null,true);
    }
    else if(value === "candidates"){
      this.valuesRetainedForFilters.emit("reset");
      this.jobService.setSliderToggle(false, value, null,true);
    }

    if (value == 'jobs applied' || value == 'job invites') {
      this.candidateService.setReset(true);
    } else if (value == 'job applicants' || value == 'candidates invited') {
      this.jobService.setReset(true);
    }
  }

  @HostListener('window:scroll')
  onScroll() {
    this.scrollPosition = window.scrollY
  }
}
